import { render, staticRenderFns } from "./discountZone.vue?vue&type=template&id=a8e6ca10&scoped=true&"
import script from "./discountZone.vue?vue&type=script&lang=js&"
export * from "./discountZone.vue?vue&type=script&lang=js&"
import style0 from "./discountZone.vue?vue&type=style&index=0&id=a8e6ca10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e6ca10",
  null
  
)

export default component.exports